import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation:  ViewEncapsulation.None
})
export class AppComponent {
    constructor(
        translateService: TranslateService) {
        translateService.setDefaultLang(environment.defaultLocale);
    }
}
